import { Table } from "@pentabd/ui";

type PromotionTableProps = {
  column: any;
  rows: any;
};

export const PensionTable = ({ column, rows }: PromotionTableProps) => {
  return (
    <Table
      columns={column || []}
      rows={rows || []}
      isStickyHeader
      height={rows.length > 6 ? 500 : undefined}
    />
  );
};
